import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UnsubscribedAlertsCreateRequestDTO } from './unsubscribe-email.interface';
import { UnSubscribeAlerts_Create } from '../GlobalVariables';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnsubscribeEmailService {

  constructor() { }
  http = inject(HttpClient);

  UnSubscribeAlerts_Create(payload: UnsubscribedAlertsCreateRequestDTO): Observable<any> {
    return this.http.post<any>(UnSubscribeAlerts_Create, payload);
  }
}
